export const sentryDsn = process.env.REACT_APP_SENTRY_CLIENT_DSN!
export const sentryEnabled = !!sentryDsn
